import {
    AvailabilityType,
    AvailableSuitesResponse,
    PricesResponseV2,
    RealSuiteNumber,
    SuiteNumber,
} from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as ROA from "fp-ts/ReadonlyArray"
import { availablePrices } from "../../_common/price-response"

type SuiteCategory = { suiteCategory: string; availability: AvailabilityType }

export class SuiteNumberValidator {
    private suiteCategories: readonly SuiteCategory[]
    private selectedSuiteCategory: string | undefined
    private availableSuites: readonly RealSuiteNumber[]
    private suiteCategoryFromSuites: string | undefined

    constructor() {
        this.suiteCategories = []
        this.availableSuites = []
        this.selectedSuiteCategory = undefined
        this.suiteCategoryFromSuites = undefined
    }

    pricesLoaded(prices: PricesResponseV2["prices"]): SuiteNumberValidator {
        this.suiteCategories = F.pipe(
            availablePrices(prices),
            ROA.map(({ availability, suiteCategory }) => ({ suiteCategory, availability })),
        )
        return this
    }

    suiteCategorySelected(suiteCategory: string): SuiteNumberValidator {
        this.selectedSuiteCategory = suiteCategory
        return this
    }

    suiteCategoryUnselected(): SuiteNumberValidator {
        this.selectedSuiteCategory = undefined
        return this
    }

    availableSuitesLoaded(response: AvailableSuitesResponse): SuiteNumberValidator {
        this.availableSuites = response.suites.map((x) => x.number)
        this.suiteCategoryFromSuites = response.suiteCategory
        return this
    }

    isValid(suiteNumber: SuiteNumber): boolean {
        const selectedSuiteCategory = this.suiteCategories.find((x) => x.suiteCategory === this.selectedSuiteCategory)
        return (
            !!selectedSuiteCategory &&
            F.pipe(
                selectedSuiteCategory.availability,
                AvailabilityType.match(
                    () => this.standardAvailabilityIsValid(suiteNumber),
                    () => suiteNumber === SuiteNumber.guaranteed,
                    noSuiteNumberIsValidForPartiallyAvailableSuiteCategory,
                ),
            )
        )
    }

    private standardAvailabilityIsValid(suiteNumber: SuiteNumber) {
        return (
            this.selectedSuiteCategory === this.suiteCategoryFromSuites &&
            F.pipe(
                suiteNumber,
                SuiteNumber.match(
                    (real) => this.availableSuites.includes(real),
                    () => false,
                ),
            )
        )
    }
}

const noSuiteNumberIsValidForPartiallyAvailableSuiteCategory = F.constFalse
